/**
 * Parser for POST `/earn/portfolio/events`.
 */

import {
    EarnChartCostPointApi,
    EarnChartNavPointApi,
    EarnPortfolioEventRowApi,
    EarnPortfolioHistoryPointApi,
    EarnPositionChartResponseApi
} from "../api/earn-events";
import {
    EarnChartCostPoint,
    EarnChartNavPoint,
    EarnPortfolioEvent,
    EarnPortfolioHistoryPoint,
    EarnPositionChartResponse
} from "../domain/earn-events";

function parseEarnPortfolioEventFromApi(api: EarnPortfolioEventRowApi): EarnPortfolioEvent {
    return {
        id: api.id,
        earnVaultAddress: api.earnVaultAddress,
        userWallet: api.userWallet,
        eventKind: api.eventKind,
        txSignature: api.txSignature,
        blockSlot: BigInt(api.blockSlot),
        blockTs: api.blockTs,
        sharesDelta: BigInt(api.sharesDelta),
        assetsDelta: BigInt(api.assetsDelta),
        feesAssets: BigInt(api.feesAssets),
        navPerShareE18AtEvent: api.navPerShareE18AtEvent,
        costBasisAfter: BigInt(api.costBasisAfter),
        realizedPnlDelta: BigInt(api.realizedPnlDelta)
    };
}

export function parseEarnPortfolioEventsFromApi(api: EarnPortfolioEventRowApi[]): EarnPortfolioEvent[] {
    return api.map(parseEarnPortfolioEventFromApi);
}

function parseEarnPortfolioHistoryPointFromApi(api: EarnPortfolioHistoryPointApi): EarnPortfolioHistoryPoint {
    return {
        timestamp: api.timestamp,
        blockSlot: BigInt(api.blockSlot),
        txSignature: api.txSignature,
        eventKind: api.eventKind,
        sharesDelta: BigInt(api.sharesDelta),
        assetsDelta: BigInt(api.assetsDelta),
        shareBalance: BigInt(api.shareBalance),
        positionAssets: BigInt(api.positionAssets),
        navPerShareE18: api.navPerShareE18,
        costBasisAssets: BigInt(api.costBasisAssets),
        realizedPnlAssets: BigInt(api.realizedPnlAssets),
        feesAssets: BigInt(api.feesAssets)
    };
}

export function parseEarnPortfolioHistoryFromApi(api: EarnPortfolioHistoryPointApi[]): EarnPortfolioHistoryPoint[] {
    return api.map(parseEarnPortfolioHistoryPointFromApi);
}

// e18 fixed-point values stay `string` in the domain; the only conversion happens at the chart
// boundary. These element parsers therefore pass the values through unchanged.
function parseEarnChartNavPointFromApi(api: EarnChartNavPointApi): EarnChartNavPoint {
    return {
        timestamp: api.timestamp,
        navPerShareE18: api.navPerShareE18
    };
}

function parseEarnChartCostPointFromApi(api: EarnChartCostPointApi): EarnChartCostPoint {
    return {
        timestamp: api.timestamp,
        costPerShareE18: api.costPerShareE18,
        isAnchor: api.isAnchor,
        eventKind: api.eventKind ?? null,
        assetsDelta: api.assetsDelta != null ? BigInt(api.assetsDelta) : null,
        shareBalance: BigInt(api.shareBalance ?? "0")
    };
}

export function parseEarnPositionChartFromApi(api: EarnPositionChartResponseApi): EarnPositionChartResponse {
    return {
        navSeries: (api.navSeries ?? []).map(parseEarnChartNavPointFromApi),
        costSeries: (api.costSeries ?? []).map(parseEarnChartCostPointFromApi)
    };
}
